module.exports = __webpack_public_path__ + "static/adsa-bronze-10899b2048fa520600cb0c4a5676112d.jpg";